import HeaderContent from "@shared/ui/header-content/header-content";
import { Button } from "primereact/button";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormPerson from "../form-person/form-person";
import { useNewCustomer } from "./new-customer.hook";

export function NewCustomer() {
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewCustomer();

  return (
    <div id="NewPerson" className="person">
      <HeaderContent
        title={<h1>New Customer</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <div className="flex gap-4">
          <Button
            label="Save"
            disabled={isCreating}
            onClick={() =>
              handleSubmit(
                (formdata) => handleValidate(formdata, true),
                handleValidateError
              )()
            }
          ></Button>
        </div>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormPerson isCustomer={true} />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewCustomer;
